import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { PersonSearchService } from 'src/app/_services/person-search.service';
import { environment } from "../../../environments/environment";
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { ReportOverLoaders } from './ReportOverviewLoaders';

declare var google;

const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009",
  "europe": "150"
}

@Component({
  selector: 'app-report-overview-tab',
  templateUrl: './report-overview-tab.component.html',
  styleUrls: ['./report-overview-tab.component.scss']
})
export class ReportOverviewTabComponent implements OnInit {
  companyDetails: any;
  topLocations: any[] = [];
  companiesGaining: any[] = [];
  companiesLosing: any[] = [];
  school: any[] = [];
  fieldOfStudy: any[] = [];
  skills: any[] = [];
  titles: any[] = [];
  currentCompanyName: any;
  dataSourceWorkCountry: any = [];
  gross_additions_by_month: number = 0;
  hireDepartureTalentMovement: any = {};
  showSchoolLoader: boolean = true;
  professionalsCount:any;
  medianTanuresCount:any;
  currentCompany:any []=[]
  currentIndustry: any []=[]
  changedJobCount:any;
  likeToMoveCount:any;
  genderDiversityMale:any;
  genderDiversityFemale:any;
  talentfilterdata: any = {};

  reportOverViewLoaders: ReportOverLoaders;
  
  subscriptions: Array<Subscription> = [];

  primaryCompanyInformation:any = {};


  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  constructor(
    private personSearchService: PersonSearchService, 
    private localstorageservice: LocalStorageService,
    private aggService: AggregationService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService
  ) { this.startLoaders(); }

  ngOnInit(): void {
    // TODO: I have to one by one sync the request of all aggregate calls and after I am done I can remove the subsc
    // this.setUpdatedData(null, true);
    // const overviewsub = this.personSearchService.gettalentinsights.subscribe(response => this.setUpdatedData(response, true));
    // this.subscriptions.push(overviewsub);
    this.setUpdatedData(null, true);

    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData(null, true));
    this.subscriptions.push(filterMethodEvent);
  }

  /**
   * TODO : Ideally I should be able to remove the talentFilterData. Need to revisit this at the end.
   * @param talentFilterData 
   */
  private setUpdatedData(talentFilterData?: any, callProffesionalCount = false) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.startLoaders();
    this.getChangeJobData();
    this.getGenderDiversity();
    // this.getLikelyToMove();
    callProffesionalCount && this.getProfessionalCount();
    this.getTopLocations();
    this.getSchool();
    this.getFieldOfStudy();
    this.getSkills();
    this.getTitles();
    this.getCompany();
    this.getIndustry();
    this.getMedianTanureCount()
  }

  getTopLocations() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "location";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.dataSourceWorkCountry = [];
    this.topLocations = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.topLocations = response?.data?.aggregations?.location ? response?.data?.aggregations?.location : [];
      this.dataSourceWorkCountry = this.aggService.createWorkCountryData(response?.data?.aggregations);
      setTimeout(() => this.loadGoogleMap());
      this.reportOverViewLoaders.topLocationsFetched = true;
    });
  }

  getSchool() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "school";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    const filterData = this.filterDataHandlerService.fetchFilterData;
    this.school = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      // const filterSchool = this.talentfilterdata && this.talentfilterdata.school && this.talentfilterdata.school.length ? this.talentfilterdata.school: [];
      const filterSchool = filterData?.schoolSelectedList?.length ? filterData.schoolSelectedList : [];
      const schoolData = response?.data?.aggregations?.school?.slice(0, 5);
      this.school = filterSchool.length ? schoolData.filter(x => filterSchool.includes(x.key)) : schoolData;
      this.reportOverViewLoaders.schoolDataFetched = true;
    });

  }

  getFieldOfStudy() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    this.fieldOfStudy = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.fieldOfStudy = response.data.aggregations.fieldofstudy.slice(0, 5);
      this.reportOverViewLoaders.fieldOfStudyDataFetched = true;
    });

  }

  getSkills() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "skills";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.skills = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.skills = response.data.aggregations.skills.slice(0, 5);
      this.reportOverViewLoaders.skillsDataFetched = true;
    });
}

  getTitles() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    this.titles = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.titles = response.data.aggregations[aggReq.aggregatetype].slice(0, 5);
      this.reportOverViewLoaders.titlesDataFetched = true;
    });
  }

  loadGoogleMap() {
    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: `${CONTINENT_MAP[this.localstorageservice.getItem('talentRegion')]}`,
        displayMode: 'markers',
        colorAxis: { colors: ['#ff7f7f', '#ffff32', '#4292ff'] }
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }
    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
 }

  getCompany() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.currentCompany = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.currentCompany = response.data.aggregations[aggReq.aggregatetype].slice(0, 5);
      this.reportOverViewLoaders.companyDataFetched = true;
    });
  }

  getIndustry() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_industry';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    this.currentIndustry = [];
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.currentIndustry = response.data.aggregations[aggReq.aggregatetype].slice(0, 5);
      this.reportOverViewLoaders.industryDataFetched = true;
    });
  }

  getProfessionalCount(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = aggReq.preferredskills ? "skills": 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.reportOverViewLoaders.isProfessionalCountCalled = false;
    this.personSearchService.getTotalAggs(aggReq).subscribe(res => {
      if(res && res.data){
        this.professionalsCount = res.data.totalresultscount;
      }
      this.reportOverViewLoaders.isProfessionalCountCalled = true;
    })
  }

  getMedianTanureCount(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "total_tenure_median";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.reportOverViewLoaders.isMedianTanureCountCalled = false;
    this.personSearchService.getTotalAggs(aggReq).subscribe(res => {
      if(res.data && res.data.aggregations && res.data.aggregations.total_tenure_median){
        this.medianTanuresCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
      }
      this.reportOverViewLoaders.isMedianTanureCountCalled = true;
    })
  }

  returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className='median-tenure-text-size';
    spanTag.innerHTML = text
    return spanTag;
  }
  
  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if(tenure == null){
      return 0;
    }else if (totalYears > 0 && totalMonths > 0) {
      if(totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if(totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
      return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }

  getLikelyToMove(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "likelytomove";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((res:any)=>{
      if(res && res.data && res.data.aggregations && res.data.aggregations.likelytomove){
        if(res.data.aggregations.likelytomove.length != 0) {this.likeToMoveCount = res.data.aggregations.likelytomove.filter(x=>x.key == 1)[0]?.doc_count}
        else{ this.likeToMoveCount = 0;}
      }
      this.reportOverViewLoaders.isLikeToMoveCalled = true;
    })
  }


  getGenderDiversity(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response:any)=>{
      if (response && response.data && response.data.aggregations && response.data.aggregations.gender.length > 0) {
        const male = response.data.aggregations.gender.length > 0 && response.data.aggregations.gender[0]?response.data.aggregations.gender[0].doc_count:0
        const female = response.data.aggregations.gender.length > 0 && response.data.aggregations.gender[1]?response.data.aggregations.gender[1].doc_count:0
        const totalCount = male+female;

        const malePercent = ((male*100)/totalCount)
        const femalePercent = ((female*100)/totalCount)

        this.genderDiversityMale = malePercent?malePercent.toFixed(0):0
        this.genderDiversityFemale = femalePercent?femalePercent.toFixed(0):0
      } else {
        this.genderDiversityFemale = 0;
        this.genderDiversityMale = 0;
      }
      this.reportOverViewLoaders.isGenderDiversityCalled = true;
    })
  }

  getIndustryIcon(industryName){
    let iconName = GlobalService.getIndustryIcon(industryName)
    return `fa-solid fa-${iconName}`
  }

  getChangeJobData(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "changedjobs";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
  
    this.personSearchService.getTotalAggs(aggReq).subscribe(res => {
      if(res && res.data && res.data.aggregations && res.data.aggregations.changedjobs){
        this.changedJobCount = res.data.aggregations.changedjobs.doc_count;
      }
      this.reportOverViewLoaders.isChangedJobCountCalled = true;
    })

  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;
    
    const additionalFilters = {};
    switch(type) {
      case 'location': additionalFilters['mandatorylocations'] = [key]; break;
      case 'company': additionalFilters['mandatorycompanies'] = [key]; break;
      case 'industry': additionalFilters['mandatoryindustries'] = [key]; break;
      case 'school': additionalFilters['mandatoryschools'] = [key]; break;
      case 'fieldofstudy': additionalFilters['mandatoryeducationalmajors'] = [key]; break;
      case 'skills': additionalFilters['mandatoryskills'] = [key]; break;
      case 'jobtitle': additionalFilters['mandatoryjobtitles'] = [key]; break;
    }

    // TODO : Handle setting other filter properties for redirection. Do the same for other connected components as well...
    this.talentfilterdata.additionalFilters = additionalFilters;
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  private startLoaders() {
    this.reportOverViewLoaders = {
      isProfessionalCountCalled: false,
      isMedianTanureCountCalled: false,
      isChangedJobCountCalled: false,
      isGenderDiversityCalled: false,
      isLikeToMoveCalled: false,
      topLocationsFetched: false,
      schoolDataFetched: false,
      fieldOfStudyDataFetched: false,
      skillsDataFetched: false,
      titlesDataFetched: false,
      industryDataFetched: false,
      companyDataFetched: false
    }
  }

  getCompanyInfo(companyname){
    let companyData = {}
    companyData = {
      companynames: [companyname]
    }
    this.personSearchService.getCompanyLogo(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.message){
        let companyDetails = res.message[0]        
        this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
        this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
        this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
        this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
        this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
        this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['id'] = res.message[0].id
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['key_id'] = res.message[0].id  
      }
    });
  }

}